const getGlobalState = (state, key) => (Array.isArray(state.liveScoreStatus[key]) ? state.liveScoreStatus[key].slice(0) : state.liveScoreStatus[key]);

export const liveScoreStatus = (state) => getGlobalState(state, 'liveScoreStatus');

export default {};